import BetManager from './BetManager'
import BetRequestBinder from './BetRequestBinder'
import Bus from '../../bus'
import { emptyBetslipState, GlobalBetslipActions } from '../../state'
import { extractBetsFromBetDtoOutcomes, logger } from '../../utils'
import { isEmpty, keyBy } from 'lodash'
import {
  BETSLIP_CLEAR_BETS_OR_BET_NOW,
  BETSLIP_STATE_UPDATE,
  BETSLIP_UPDATE_BET,
  BETSLIP_UPDATE_ERRORS
} from '../../actions'
import { BET_STATUSES, BET_TYPE, BETSLIP_VALIDATION_STATUS } from '../../constants'
import { BETSLIP_ERROR_CODE } from '../../error'

const $bettor = new BetManager()
const requestBinder = new BetRequestBinder()

/*
  Handler that resolving initial bets for betslip:main
  once authorization resolved via login
  Bus.on(Bus.events.auth.login, (profile) => {
    $bettor.getActiveBets()
      .then(requests => {
        if (isEmpty(requests)) {
          logger.debug('[BetManager] active bets requests not found')
        }

        logger.debug('[BetManager] resolving active bets requests=', requests)

        const betItems = []

        for (const request of requests) {
          requestBinder.bindRequestIdWithBetslip(
            request.placeBetRequestId,
            'main'
          )

          for (const bet of request.bets) {
            const bets = extractBetsFromBetDtoOutcomes(bet.outcomes)

            betItems.push(...bets)
          }
        }

        return betItems
      })
      /*
      TODO: Need to dispatch set bets action
      .then(betItems => {
        Bus.emit('betslip:main', {
          type: BETSLIP_STATE_UPDATE,
          payload: {
            loading: true,
            betItems
          }
        })
      })
  })
*/

Bus.on(Bus.events.auth.resolved, () => {
  $bettor.getActiveBets()
    .then(requests => {
      if (isEmpty(requests)) {
        logger.debug('[BetManager] active bets requests not found')

        return $bettor.betStorage.resolveBetItems()
          .then(betItems => {
            return {
              betItems,
              loading: false
            }
          })
      }

      logger.debug('[BetManager] resolving active bets requests=', requests)

      const betItems = []
      const betReports = []
      for (const request of requests) {
        // Binding request id to main betslip
        requestBinder.bindRequestIdWithBetslip(
          request.placeBetRequestId,
          'main'
        )

        // Creating bet items from request bets
        for (const bet of request.bets) {
          if (bet.betStatus === BET_STATUSES.PENDING_APPROVAL) {
            betReports.push(bet)
          } else {
            const bets = extractBetsFromBetDtoOutcomes(bet.outcomes)
            betItems.push(...bets)
          }
        }
      }

      return {
        betItems,
        betReports,
        // This is never resolved?
        loading: false // true
      }
    })
    .then(options => {
      $bettor.betslipInitialOptions.resolve(options)
    })
    .catch(error => {
      $bettor.betslipInitialOptions.reject(error)
    })
})

Bus.on(Bus.events.auth.unresolved, () => {
  $bettor.betStorage.resolveBetItems()
    .then(betItems => {
      $bettor.betslipInitialOptions.resolve({
        betItems,
        loading: false
      })
    })
    .catch(error => {
      $bettor.betslipInitialOptions.reject(error)
    })
})

/*
  Handler for betslip registrations needed for place bet operations
*/
Bus.on(Bus.events.bet.placing, ({ requestId, betslipId }) => {
  const betslipNamespace = `betslip:${betslipId}`
  logger.debug(`[${betslipNamespace}] ✔️ registering placeBetRequestId=${requestId}`)

  // Broadcasting betslip state update
  // Enabling loading & cleaning errors
  Bus.emit(betslipNamespace, {
    type: BETSLIP_STATE_UPDATE,
    payload: {
      loading: true,
      errors: emptyBetslipState.errors,
      outcomesErrors: emptyBetslipState.outcomesErrors
    }
  })

  // Cleaning global betslip reports
  Bus.emit('betslip:global', {
    type: GlobalBetslipActions.BETSLIP_CLEAR_REPORTS,
    payload: { }
  })

  requestBinder.bindRequestIdWithBetslip(
    requestId,
    betslipId
  )
})

Bus.on(Bus.events.bet.placedResult, ({ data }) => {
  const {
    placeBetRequestId,
    bets,
    code,
    errors
  } = data

  logger.debug(
    '[BetManager:placedResult] ✔️',
    `placeBetRequestId=${placeBetRequestId} code=${code}`
  )

  requestBinder.resolveBetslipIdByRequestId(placeBetRequestId)
    .then(betslipId => {
      const betslipNamespace = `betslip:${betslipId}`

      logger.debug(`[${betslipNamespace}] ✔️ dispaching place bet placedResult; placeBetRequestId=${placeBetRequestId}`)

      // Updating betslip loading state
      Bus.emit(betslipNamespace, {
        type: BETSLIP_STATE_UPDATE,
        payload: {
          loading: false
        }
      })

      if (bets?.length) {
        // success placed bets
        if (bets[0]?.betType === BET_TYPE.SINGLE) {
          bets.forEach(bet => Bus.emit(betslipNamespace, {
            /* type: BETSLIP_REMOVE_BET,
            payload: {
              outcomeId: bet.outcomes[0]?.outcomeId,
              requestId: bet.requestId
            } */
            type: BETSLIP_UPDATE_BET,
            payload: {
              requestId: bet.requestId,
              amount: 0,
              alreadyPlaced: true
            }
          }))
        } /* else { // if only multi bet
          Bus.emit(betslipNamespace, {
            type: BETSLIP_STATE_UPDATE,
            payload: {
              // Cleaning bets after successfull place bet
              betItems: emptyBetslipState.betItems,
              betTypes: emptyBetslipState.betTypes
            }
          })
        } */
      }

      if (errors?.length) {
        // some bet placed errors
        Bus.emit(betslipNamespace, {
          type: BETSLIP_UPDATE_ERRORS,
          payload: keyBy(errors, error => error.requestId || 'global')
        })
      } else {
        // Cleaning bets after successfull place bet
        Bus.emit(betslipNamespace, {
          type: BETSLIP_CLEAR_BETS_OR_BET_NOW,
          payload: {}
        })
      }
    })
    .catch((error) => {
      logger.debug(
        '[BetManager:placedResult] ❌',
        `unable to resolve betslip by placeBetRequestId=${placeBetRequestId}:`,
        error.message
      )
    })
    .finally(() => {
      requestBinder.unbindRequestId(placeBetRequestId)
    })
})

Bus.on(Bus.events.bet.interceptResolve, ({ data }) => {
  const {
    betId
  } = data

  logger.debug(
    '[BetManager:betIntercetResolved] ✔️',
    `betId=${betId}`, data
  )
})

Bus.on(Bus.events.bet.placedFail, ({ data }) => {
  const {
    placeBetRequestId,
    code,
    errors
  } = data

  logger.debug(
    '[BetManager:placedFail] ❌',
    `placeBetRequestId=${placeBetRequestId} code=${code}`
  )

  requestBinder.resolveBetslipIdByRequestId(placeBetRequestId)
    .then(betslipId => {
      const betslipNamespace = `betslip:${betslipId}`

      logger.debug(`[${betslipNamespace}] ❌ dispaching place bet failed; placeBetRequestId=${placeBetRequestId}`)

      if (isEmpty(errors)) {
        // If not errors provided in fail place bet
        // Broadcasting internal error
        return Bus.emit(betslipNamespace, {
          type: BETSLIP_UPDATE_ERRORS,
          payload: {
            global: {
              requestId: 'global',
              violations: [
                {
                  code: BETSLIP_VIOLATION.INTERNAL_ERROR
                }
              ]
            }
          }
        })
      }

      Bus.emit(betslipNamespace, {
        type: BETSLIP_UPDATE_ERRORS,
        payload: keyBy(errors, error => error.requestId || 'global')
      })
    })
    .catch((error) => {
      logger.debug(
        '[BetManager:placedFail] ❌',
        `unable to resolve betslip by placeBetRequestId=${placeBetRequestId}:`,
        error.message
      )
    })
    .finally(() => {
      requestBinder.unbindRequestId(placeBetRequestId)
    })
})

Bus.on(Bus.events.bet.validationSuccess, response => {
  logger.info('[BetManager]', '✔️', 'bets validation succeeded')
})

Bus.on(Bus.events.bet.validationError, data => {
  const {
    code,
    errors
  } = data

  logger.info('[betslip:main]', '❌', `bets validation failed; code=${code}`, errors)

  // For validation failed code - dispatching errors to main betslip state
  if (code === BETSLIP_ERROR_CODE.BET_VALIDATION_FAILED) {
    return Bus.emit('betslip:main', {
      type: BETSLIP_UPDATE_ERRORS,
      payload: keyBy(errors, error => error.requestId || 'global')
    })
  }

  // For unexpected error type
  Bus.emit('betslip:main', {
    type: BETSLIP_STATE_UPDATE,
    payload: {
      loading: false,
      validationStatus: BETSLIP_VALIDATION_STATUS.VALIDATION_FAILED
    }
  })
})

Bus.on(Bus.events.bet.orderSuccess, response => {
  logger.info('[betslip:order]', '✔', 'order bet successfully placed', response)
})

Bus.on(Bus.events.bet.orderSuccess, error => {
  logger.info('[betslip:order]', '❌', 'order bet error placed', error)
})

// Storing main betslip snapshots
Bus.on(`betslip:main:${Bus.events.bet.snapshot}`, ({ betItems = [] }) => {
  // Setting bets items in storage
  logger.debug(`[betslip:main:${Bus.events.bet.snapshot}]`, '📸')
  $bettor.betStorage.setBetItems(betItems.filter(bet => !bet.betNow))
})

export default $bettor
